import { render, staticRenderFns } from "./ImagesTab.vue?vue&type=template&id=b1aa935a&scoped=true&"
import script from "./ImagesTab.vue?vue&type=script&lang=js&"
export * from "./ImagesTab.vue?vue&type=script&lang=js&"
import style0 from "./ImagesTab.vue?vue&type=style&index=0&id=b1aa935a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aa935a",
  null
  
)

export default component.exports